import { createFileRoute, redirect } from "@tanstack/react-router";
import { lastScope } from "../../app/scope";

export const Route = createFileRoute("/_authed/$org/spot/")({
  validateSearch: (s: Record<string, unknown>) => ({ ...(typeof s.workspace === "string" ? { workspace: s.workspace } : {}) }),
  beforeLoad: ({ context, params, search }) => {
    const project = lastScope(context.session.user.id).project(params.org);
    throw redirect({ href: `/${encodeURIComponent(params.org)}/${encodeURIComponent(project)}/instances${search.workspace ? `/new?capacity=spot&workspace=${encodeURIComponent(search.workspace)}` : ""}`, replace: true });
  },
});
